import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpsertBlockedShippingCompanyForCustomer = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpsertBlockedShippingCompanyForCustomer,
        method: RequestType.POST,
        data,
    });

const DeleteBlockedShippingCompanyForCustomer = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.DeleteBlockedShippingCompanyForCustomer}`,
        method: RequestType.POST,
        data,
    });
const GetByCustomerIdBlockedShippingCompanyForCustomer = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetByCustomerIdBlockedShippingCompanyForCustomer}`,
        method: RequestType.POST,
        data,
    });
const GetShippingCompanyServiceDistributionListByShippingCompanyIdAndAddressEntityId = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetShippingCompanyServiceDistributionListByShippingCompanyIdAndAddressEntityId}`,
        method: RequestType.POST,
        data,
    });
const GetShippingCompanyServiceDistributionListByShippingCompanyId = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.GetShippingCompanyServiceDistributionListByShippingCompanyId}`,
        method: RequestType.POST,
        data,
    });
const UpsertShippingCompanyServiceDistribution = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpsertShippingCompanyServiceDistribution}`,
        method: RequestType.POST,
        data,
    });
const UpsertShippingCompanyServiceDistributionFromExcel = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpsertShippingCompanyServiceDistributionFromExcel}`,
        method: RequestType.POST,
        data,
        requestType: 'FromForm',
    });
const AddDigitalCardTemplates = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.AddDigitalCardTemplates}`,
        method: RequestType.POST,
        data,
        skipContentType: true,
    });
const UpdateDigitalCardTemplates = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.UpdateDigitalCardTemplates}`,
        method: RequestType.POST,
        data,
        skipContentType: true,
    });
const DeleteDigitalCardTemplates = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteDigitalCardTemplates,
        method: RequestType.DELETE,
        data,
    });
const UpdateDigitalCardDisplayOrder = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateDigitalCardDisplayOrder,
        method: RequestType.PUT,
        data,
    });
const ReSendLabelMessage = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ReSendLabelMessage,
        method: RequestType.POST,
        data,
    });
const GetWaitingForShipments = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetWaitingForShipments,
        method: RequestType.POST,
        data,
    });
const RequestPickupForShipments = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.RequestPickupForShipments,
        method: RequestType.POST,
        data,
    });

const ListEtbisReports = (data?: any): Promise<any> =>
    request({
        url: ApiURL.Command.ListEtbisReports,
        method: RequestType.POST,
        data: data || {},
    });

const DownloadEtbisReport = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DownloadEtbisReport,
        method: RequestType.POST,
        data,
        responseType: 'blob',
        skipBlobAutoOpen: true,
    });

const DeleteEtbisReport = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteEtbisReport,
        method: RequestType.POST,
        data,
    });

const PostCheckoutCommand = {
    UpsertBlockedShippingCompanyForCustomer,
    DeleteBlockedShippingCompanyForCustomer,
    GetByCustomerIdBlockedShippingCompanyForCustomer,
    GetShippingCompanyServiceDistributionListByShippingCompanyIdAndAddressEntityId,
    GetShippingCompanyServiceDistributionListByShippingCompanyId,
    UpsertShippingCompanyServiceDistribution,
    UpsertShippingCompanyServiceDistributionFromExcel,
    DeleteDigitalCardTemplates,
    UpdateDigitalCardTemplates,
    AddDigitalCardTemplates,
    UpdateDigitalCardDisplayOrder,
    ReSendLabelMessage,
    GetWaitingForShipments,
    RequestPickupForShipments,
    ListEtbisReports,
    DownloadEtbisReport,
    DeleteEtbisReport,
};

export default PostCheckoutCommand;
